import * as angular from 'angular';

import { IFrequency, ComponentDefinition, IFrequencyValidationRule, KeyValuePair } from '../../models';
import { TimeUnit } from '../../models/enum';

declare type SelectType = 'timeUnit' | 'allTimeUnit' | 'supplied';

class FrequencyPickerController implements angular.IComponentController {
    field: string;
    fieldInterval: string;
    formController: angular.IFormController;
    interval: number;
    intervalTimeUnit: TimeUnit;
    isDisabled: boolean;
    min: number;
    onFrequencyChange?: (value: { frequency: IFrequency }) => void;
    reduced: boolean;
    selectType: SelectType;
    timeUnits?: KeyValuePair<TimeUnit, string>[];
    validationRules: IFrequencyValidationRule[];

    static $inject = [];

    $onInit() {
        if (!this.field) {
            this.field = 'intervalProperty';
        }
        this.fieldInterval = `${this.field}Interval`;
        this.selectType = this.getSelectType();
    }

    onChange(value?: TimeUnit) {
        if (this.validationRules && this.validationRules.length) {
            const frequency: IFrequency = {
                interval: this.interval,
                intervalTimeUnit: arguments.length ? value : this.intervalTimeUnit
            };
            if (this.formController) {
                this.validate(frequency);
            }
        }
        this.selectType = this.getSelectType();
        if (this.onFrequencyChange) {
            this.onFrequencyChange({ frequency: { interval: this.interval, intervalTimeUnit: arguments.length ? value : this.intervalTimeUnit } });
        }
    }

    canSelectUnit() {
        return this.isDisabled || ((!!this.min || this.min === 0) && this.interval < this.min);
    }

    private getSelectType() {
        let selectType: SelectType;
        if (this.timeUnits) {
            selectType = 'supplied';
        } else if (this.reduced) {
            selectType = 'timeUnit';
        } else {
            selectType = 'allTimeUnit';
        }
        return selectType;
    }

    private validate(frequency: IFrequency) {
        for (let i = 0; i < this.validationRules.length; i++) {
            const r = this.validationRules[i];
            const isValid = r.isValid(frequency);
            this.formController[this.field + 'Interval'].$setValidity(r.key, isValid);
            this.formController[this.field + 'intervalUnit'].$setValidity(r.key, isValid);
            if (!isValid) {
                break;
            }
        }
    }
}

export const wtFrequencyPicker: ComponentDefinition = {
    componentId: 'wtFrequencyPicker',
    controller: FrequencyPickerController,
    controllerAs: 'vm',
    template: require('./frequencyPicker.component.html'),
    bindings: {
        field: '@?',
        formController: '<?',
        interval: '=',
        intervalTimeUnit: '=',
        isDisabled: '<?',
        min: '<?',
        onFrequencyChange: '&?',
        reduced: '<?',
        required: '<?',
        timeUnits: '<?',
        validationRules: '<?'
    }
};